import { environment } from '../../../environments/environment';
import type { RuntimeAppConfig } from '../../../environments/environment.model';
import { applyRuntimeConfig } from '../../../environments/runtime-config.util';

const DEFAULT_RUNTIME_CONFIG_URL = '/assets/config.json';

async function fetchRuntimeConfig(url: string): Promise<RuntimeAppConfig> {
  const response = await fetch(url, {
    cache: 'no-store',
    headers: { Accept: 'application/json' },
  });

  if (response.status === 404) {
    return {};
  }

  if (!response.ok) {
    throw new Error(
      `Failed to load runtime config from ${url} (${response.status})`,
    );
  }

  const raw = await response.text();
  if (!raw.trim()) {
    return {};
  }

  const payload = JSON.parse(raw) as RuntimeAppConfig;
  return payload ?? {};
}

export function provideRuntimeConfigInitializer(): () => Promise<void> {
  return async () => {
    if (environment.useRuntimeConfig === false) {
      return;
    }

    const configUrl =
      environment.runtimeConfigUrl?.trim() ?? DEFAULT_RUNTIME_CONFIG_URL;

    try {
      const runtimeConfig = await fetchRuntimeConfig(configUrl);
      applyRuntimeConfig(environment, runtimeConfig);
    } catch (error) {
      if (environment.production) {
        console.error('[RuntimeConfig] Unable to load deploy-time configuration', error);
      }
    }
  };
}
